import { CgBreakpoints } from "../../components/common/cgBreakpoints";
import { MediaImage } from "../../components/media/mediaImage";
import { Slider } from "../../components/slider/slider";
import { debounce } from "underscore";


export class StructureColumn {
    buttonTPL = [
        '<p class="pagination-browser">',
        '<button type="button" class="pagination-browser__button">Ver Más</button>',
        '</p>'
    ].join('');

    resizeStructure = true;

    constructor(defaultOptions, slidesPerView, structureClass) {
        this.defaultOptions = defaultOptions;
        this.slidesPerView = slidesPerView;
        this.structureClass = structureClass;
        this.structures = $(structureClass);

        this.init();
    }

    init() {
        if (!this.structures.length) {
            return;
        }

        this.update();

        $(window).resize(debounce(() => {
            if (this.resizeStructure) {
                this.update();
            }
        }));
    }

    update() {
        if (!this.isMobile()) {
            new Slider(this.structures, this.defaultOptions);
        } else {
            this.addButton();
            this.bindEvents();
            this.resizeStructure = false;
        }
    }

    bindEvents() {
        this.structures.find('.pagination-browser__button').each((index, button) => {
            button.addEventListener('click', (evt) => {
                evt.preventDefault();

                this.showCards(button);
            })
        });
    }

    showCards(button) {
        const structure = button.closest(this.structureClass);
        const hiddenSlides = this.getHiddenElements($(structure));

        hiddenSlides.slice(0, this.slidesPerView).fadeIn(() => {
            this.loadImages();
        });

        if (!this.hasHiddenElments($(structure))) {
            this.removeButton(button);
        }
    }

    // auxiliary
    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }

    hasHiddenElments(structure) {
        return !!structure.find(this.defaultOptions.slideClassHidden + ':hidden').length;
    }

    getHiddenElements(structure) {
        return structure.find(this.defaultOptions.slideClassHidden).filter(':hidden');
    }

    addButton() {
        this.structures.has(this.defaultOptions.slideClassHidden + ':hidden').append(this.buttonTPL);
    }

    removeButton(button) {
        button.remove();
    }

    loadImages() {
        new MediaImage();
    }
}
